import { configureI18n } from '@applyboard/ui-utils';
import enUsTranslation from "./locales/en-US/translation.json";
export var defaultNS = 'translation'; // Default name space

var i18n = configureI18n({
  'en-US': {
    translation: enUsTranslation
  }
});
export default i18n;